/* tslint:disable */
import { Translation } from './translation';

/**
 */
export class DisplayAllLangs {
    langName?: Translation[][];
    referenceLangs?: Translation[][];
    translationLangs?: Translation[][];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/display-all-langs.ts